import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import emailjs from "@emailjs/browser";

import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

import routes from "routes";
import footerRoutes from "footer.routes";

import bgImage from "assets/images/quadroNegro.jpg";
import ReCAPTCHA from "react-google-recaptcha";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [captchaValue, setCaptchaValue] = useState(null);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!captchaValue) {
      alert("Por favor, verifique o CAPTCHA antes de enviar.");
      return;
    }

    const templateParams = {
      to_name: "Equipe Suporte",
      from_name: formData.name,
      message: formData.message,
      from_email: formData.email,
    };

    emailjs.send("service_1lnz61z", "template_81t9b8b", templateParams, "fKQRUXT-xS_iTv-4C").then(
      (response) => {
        console.log("E-mail enviado com sucesso!", response.status, response.text);
        alert("Mensagem enviada com sucesso!");
        setFormData({ name: "", email: "", message: "" });
        setCaptchaValue(null);
      },
      (error) => {
        console.log("Erro ao enviar e-mail:", error);
        alert("Erro ao enviar mensagem. Tente novamente.");
      }
    );
  };

  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar
          routes={routes}
          action={{
            type: "external",
            route: "https://ifpr.edu.br/irati/",
            label: "IFPR",
            color: "info",
          }}
        />
      </MKBox>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} lg={6}>
          <MKBox
            display={{ xs: "none", lg: "flex" }}
            width="calc(100% - 2rem)"
            height="calc(100vh - 2rem)"
            borderRadius="lg"
            ml={2}
            mt={2}
            sx={{ backgroundImage: `url(${bgImage})` }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={10}
          md={7}
          lg={6}
          xl={4}
          ml={{ xs: "auto", lg: 6 }}
          mr={{ xs: "auto", lg: 6 }}
        >
          <MKBox
            bgColor="white"
            borderRadius="xl"
            shadow="lg"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            mt={{ xs: 20, sm: 18, md: 20 }}
            mb={{ xs: 20, sm: 18, md: 20 }}
            mx={3}
          >
            <MKBox
              variant="gradient"
              bgColor="info"
              coloredShadow="info"
              borderRadius="lg"
              p={2}
              mx={2}
              mt={-3}
            >
              <MKTypography variant="h3" color="white">
                Contato
              </MKTypography>
            </MKBox>
            <MKBox p={3}>
              <MKTypography variant="body2" color="text" mb={3}>
                Para dúvidas ou um contato extra, preencha os formulários a seguir:
              </MKTypography>
              <MKBox width="100%" component="form" autoComplete="off" onSubmit={sendEmail}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <MKInput
                      variant="standard"
                      label="Nome completo"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MKInput
                      type="email"
                      variant="standard"
                      label="Email"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MKInput
                      variant="standard"
                      label="Como podemos ajudar?"
                      placeholder="Descreva em até 250 caracteres."
                      InputLabelProps={{ shrink: true }}
                      multiline
                      fullWidth
                      rows={6}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                </Grid>
                <Grid container item justifyContent="center" xs={12} mt={3}>
                  <ReCAPTCHA
                    sitekey="6LfUbI0rAAAAAJpjRhZNF9io-42TxLgaA3d7b8rR"
                    onChange={(value) => setCaptchaValue(value)}
                  />
                </Grid>
                <Grid container item justifyContent="center" xs={12} mt={5} mb={2}>
                  <MKButton type="submit" variant="gradient" color="info">
                    Enviar mensagem
                  </MKButton>
                </Grid>
              </MKBox>
            </MKBox>
          </MKBox>
        </Grid>
      </Grid>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ContactUs;
